import React from "react";
import { Container } from "react-bootstrap";
import Particle from "../Particle";

function Casting() {
  return (
    <Container fluid className="project-section">
      <Particle />

      <Container>
        {/* Main heading */}
        <h3 style={{ fontSize: "2.5em", color: "white" }}>
          <span className="purple">Collaborations</span>
        </h3>

        {/* Subheading */}
        <h3 style={{ fontSize: "1.5em", color: "white" }}>
          <span className="purple">Global Collaborations</span>
        </h3>

        {/* Paragraphs */}
        <p style={{ color: "white" }}>
          I collaborate with creators and actresses all around the world.
        </p>
            
        <h3 style={{ fontSize: "1.5em", color: "white" }}>
          <span className="purple">Important Considerations</span>
        </h3>

        <p style={{ color: "white" }}>
          The most important things to me are safety, security, and the enjoyment of the experience in making content together.
        </p>

        <h3 style={{ fontSize: "1.5em", color: "white" }}>
          <span className="purple">Testing is Required</span>
        </h3>

        <p style={{ color: "white" }}>
          I am consistently tested and require all co-performers and collaborators to be as well.
        </p>

        <h3 style={{ fontSize: "1.5em", color: "white" }}>
          <span className="purple">Content Sharing</span>
        </h3>

        <p style={{ color: "white" }}>
          For collaborations, content is shared between creators and actors involved.
        </p>

        <h3 style={{ fontSize: "1.5em", color: "white" }}>
          <span className="purple">Contact</span>
        </h3>

        <p style={{ color: "white" }}>
          For more information, please reach out via email or social media.
        </p>

        {/* Email as a separate heading or styled paragraph */}
        <h3 style={{ fontSize: "1.5em", color: "white", marginTop: "2rem" }}>
          <span className="purple">AndresAcostaXXX1@gmail.com</span>
        </h3>
      </Container>
    </Container>
  );
}

export default Casting;
